import React from "react";

import { ApiGmwGmwsListRequest } from "@nens/brostar/openapi-client";

import { SearchBox } from "@/components/searchbox";

import { gmwInformation } from "../types";

type Props = {
  showGmnFilter: boolean;
  searchField: keyof ApiGmwGmwsListRequest;
  setSearchField: (searchField: keyof ApiGmwGmwsListRequest) => void;
  searchString: string;
  setSearchString: (searchString: string) => void;
};

const GmwFilters: React.FC<Props> = ({
  searchField,
  setSearchField,
  searchString,
  setSearchString,
}) => {
  return (
    <>
      <SearchBox
        searchField={searchField}
        setSearchField={setSearchField}
        searchString={searchString}
        setSearchString={setSearchString}
        searchOptions={gmwInformation}
      />
      {/* FUTURE: Enable this once there are filters that support it in the backend */}
      {/* {showGmnFilter && <GmnFilterPopover filters={filters} setFilters={setFilters} />} */}
    </>
  );
};

export { GmwFilters };
